// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8b071aa0","498":"996d8fbf","703":"070c19ec","787":"751101f5"}[chunkId] + ".chunk.js";
};